export default {
  signInNotRegistered: "Нет учётной записи ?",
  signInRegister: "Регистрация",
  message: "Русский",

  logout: "Выйти",
  LoginPersonalAcc: "Вход в Личный кабинет",
  getCode: "Получить код",
  Enter: "Вход",
  verificationCode: "Проверочный код",

  reports: "Отчеты",
  sales_summary: "Итоги продаж",
  abc_analysis: "ABC-анализ",
  sales_by_item: "Продажи товаров",
  sales_by_category: "Продажи по категорий",
  sales_by_employee: "Продажи по сотрудникам",
  sales_by_payment: "Продажи по типам оплаты",
  receipts: "Чеки",
  debts: "Долги",
  discounts: "Скидки",
  taxes: "Налоги",
  shifts: "Кассовые смены",

  items: "Товары",
  item_list: "Список товаров",
  categories: "Категории",
  modifiers: "Модификаторы",

  inventory_management: "Складской учет",
  purchase_orders: "Заказы на поставку",
  transfer_orders: "Перемещения",
  stock_adjusment: "Корректировки остатков",
  inventory_counts: "Инвентаризация",
  productions: "Производство",
  suppliers: "Поставщики",
  inventory_history: "История движения товаров",
  inventory_valuation: "Стоимость остатков",

  employees: "Сотрудники",
  employee_list: "Список сотрудников",
  access_rights: "Права доступа",
  timecards: "Смены",
  total_hours_worked: "Общее отработанное время",

  customers: "Клиенты",
  online_kassa: "Продажа",

  settings: "Настройки",
  general: "Общие",
  payment_types: "Типы оплаты",
  loyalty: "Лояльность",
  open_tickets: "Открытые чеки",
  kitchen_printers: "Кухонные принтеры",
  stores: "Заведения",
  pos_devices: "Кассы",

  all_day: "Весь день",
  custom: "Другой период",
  start: "Начало",
  end: "Окончание",
  all_stores: "Все заведения",
  all_employes: "Все сотрудники",
  all_employees: "Все сотрудники",
  all_reasons: "Все причины",
  gross_sales: "Продажи",
  refunds: "Возвраты",
  net_sales: "Выручка",
  gross_profit: "Валовая прибыль",
  date: "Дата",
  cost_of_goods: "Себестоимость товаров",

  item_name: "Название товара",
  items_sold: "Проданные товары",
  gross_profit_analysis: "Анализ валовой прибыли",
  net_sales_analysis: "Анализ выручки",
  gross_sales_analysis: "Анализ продаж",

  item: "Товар",
  sku: "Артикул",
  category: "Категория",
  items_refunded: "Возвращенные товары",

  average_sale: "Средняя продажа",

  payment_type: "Тип оплаты",
  payment_transactions: "Количество оплат",
  payment_amount: "Сумма оплат",
  refund_transactions: "Количество возвратов",
  refund_amount: "Сумма возвратов",
  net_amount: "Итоговая сумма",

  all: "Все",
  sales: "Продажи",
  sold: "Продано",
  receipt_no: "№ чека",
  store: "Заведение",
  employee: "Сотрудник",
  customer: "Клиент",
  type: "Тип",
  total: "Итого",
  cashier: "Кассир",
  pos: "Касса",

  donator: "Жертвователь",
  accepted_time: "Принятое время",
  receiver: "Принимающее лицо",
  receive: "Получать",
  charged: "Заряжено",

  name: "Название",
  discount_applied: "Скидок применимо",
  amount_applied: "Сумма скидок",

  taxable_sales: "Облагаемая налогом выручка",
  non_taxable_sales: "Необлагаемая налогом выручка",
  total_net_sales: "Общая выручка",
  tax_name: "Название налога",
  tax_amount: "Сумма налога",

  opening_time: "Время открытия",
  closing_time: "Время закрытия",
  exp_cash_amount: "Ожидаемая сумма наличных",
  act_cash_amount: "Фактическая сумма наличных",
  difference: "Разница",
  shift_report: "Отчет о смене",
  shift_opened: "Открытие смены",
  shift_closed: "Закрытие смены",
  cash_drawer: "Денежный ящик",
  starting_cash: "Наличный",
  cash_payments: "Наличный расчет",
  cash_refunds: "Возврат денежных средств",
  paid_in: "Оплачено в",
  paid_out: "Выплаченый",

  add_item: "Добавить товар",
  import: "Импорт",
  export: "Экспорт",
  upload: "Загрузить",
  print_labels: "Печать этикетки",
  stock_alert: "Остаток",
  create_item: "Создать товар",
  update_item: "Обновить товар",
  sold_by: "Продается",
  each: "Поштучно",
  weight: "На вес",
  price: "Цена",
  cost: "Себестоимость",
  barcode: "Штрихкод",
  inventory: "Учет остатков",
  composite_item: "Составной товар",
  online_store: "Онлайн магазин",
  track_stock: "Вести учет остатков",
  use_production: "Использование производства",
  quantity: "Количество",
  you_have_not_selected_items_yet: "Вы еще не выбрали элементы",
  available: "Доступно",
  primary_supplier: "Основной поставщик",
  default_purchase_cost: "Стоимость покупки по умолчанию",
  in_stock: "В наличии",
  all_items: "Все товары",
  low_stock: "Низкий запас",
  equal_to_zero: "Равен нулю",
  out_of_stock: "Нет на складе",
  positive: "Положительный",
  optimal_stock: "Оптимальный запас",
  representation: "Отображение товара",
  color_and_shape: "Цвет и форма",
  square: "Прямоугольник",
  circle: "Круг",
  octagonal: "Восьмиугольник",
  hexagon: "Шестиугольник",
  cancel: "Отмена",
  create: "Создать",
  label_type: "Тип этикетки",
  barcode_source_field: "Источник штрихкода",
  print_name: "Печатать название",
  print_price: "Печатать цену",
  add_by_category: "Добавить по категории",
  add_by_supplier: "Добавить по поставщику",
  please_add_at_least_one_item: "Пожалуйста, добавьте хотя бы один товар",
  print: "Распечатать",
  create_labels: "Создать этикетки",

  add_category: "Добавить категорию",
  delete: "Удалить",
  create_category: "Создать категорию",
  category_name: "Название категории",
  update: "Обновить",

  add_modifier: "Добавить модификатор",
  modifier: "Модификатор",
  modifier_name: "Название модификатора",
  option_name: "Название опции",
  add_option: "Добавить опцию",
  save: "Сохранить",

  add_discount: "Добавить скидку",
  value: "Шт.",
  percentage: "Процент",
  amount: "Сумма",

  add_purchase: "Добавить заказ",
  tin: "Пинфл",

  status: "Статус",
  supplier: "Поставщик",
  purchase_order: "Складской учет",
  received: "Было принято",
  exp_on: "Ожидаемая дата поставки",
  create_purchase: "Создать покупку",
  purchase_order_date: "Дата заказа",
  expected_on: "Ожидаемая дата поставки",
  note: "Заметка",
  incoming: "Ожидается",
  purchase_cost: "Цена закупки",
  add_additional_cost: "Добавить дополнительные расходы",
  additional_cost: "Дополнительный расход",
  ordered_by: "По заказу",
  destination_store: "Назначение заведения",
  closed: "Закрыто",
  pending: "Рассматривается",
  returned_order: "Возвращенные заказы",
  partially: "Частично",
  notes: "Заметки",

  add_transfer: "Добавить перемещение",
  add_online_stores: "Добавить интернет магазин",
  transfer_order: "Перемещение",
  source_store: "Отправитель",
  create_transfer: "Создать перемещение",
  date_of_tranfer_order: "Дата перемещения",
  source_stock: "Остаток отправителя",
  destination_stock: "Остаток получателя",
  in_transit: "В транзите",
  transferred: "Переданы",
  edit: "изменить",
  more: "больше",
  canceled: "отменен",

  add_stock_adjustment: "Добавить корректировку",
  reason: "Причина",
  receive_items: "Получение товара",
  returned_back: "Вернулся обратно",
  returned: "Вернулся",
  recounted: "Пересчитан",
  inventory_count: "Инвентаризация",
  recount: "Инвентаризация",
  loss: "Утеря товара",
  lost: "Потерял",
  "item edit": "Отредактирован",
  damage: "Повреждение товара",
  damaged: "Поврежденные",
  create_stock_adjustment: "Создать корректировку",
  add_stock: "Получено",
  stock_after: "Остаток после",
  all_stock_adjustment: "Все корректировки остатков",
  adjusted_by: "Регулируется",
  expected_stock: "Ожидаемый остаток",
  counted_stock: "Подсчитанный остаток",
  remove_stock: "Удалить товар",

  add_inventory_count: "Добавить инвентаризацию",
  in_progress: "В прогрессе",
  completed: "Окончено",
  date_created: "Дата создания",
  date_completed: "Дата окончания",
  create_inventory_count: "Создать расчет инвентаризации",
  partial: "Частичная",
  full: "Полная",
  created_by: "Было создано",
  counted: "Подсчитано",
  cost_difference: "Разница в стоимости",
  count_stock: "Инвентаризация",

  add_production: "Добавить производство",
  production: "Производство",
  disassembly: "Разборка",
  create_production: "Создать производство",

  add_supplier: "Добавить поставщика",
  contact: "Контактное лицо",
  phone_number: "Телефон",
  email: "Email",
  create_supplier: "Создать поставщика",
  supplier_name: "Название поставщика",
  website: "Веб-сайт",
  address: "Адрес",
  address_1: "Адрес 1",
  address_2: "Адрес 2",
  city: "Город",
  postal_zip_code: "Индекс",
  country: "Страна",
  region_state_province: "Регион/Штат/Область",

  adjustment: "Корректировка",

  total_inventory_value: "Общая стоимость остатков",
  total_retail_value: "Общая розничная стоимость",
  potential_profit: "Потенциальная прибыль",
  margin: "Маржа",
  inventory_value: "Стоимость остатков",
  retail_value: "Розничная стоимость",

  add_employee: "Добавить сотрудника",
  role: "Рол",
  password: "Пароль",

  add_role: "Добавить рол",
  access: "Доступ",
  employees_can_log_in_to_the_app_using_personal_PIN_code:
    "Сотрудники могут входить в приложение, используя свой PIN-код",
  close_ticket: "Закрыть чек",
  print_pre_check: "Предварительная проверка печати",
  refund: "Возврат товаров",
  show_all_receipts: "Показать все квитанции",
  pay_debt: "Заплатить долг",
  show_shift_history: "Показать историю смены",
  apply_discount: "Применить скидку",
  change_settings: "Изменить настройки",
  show_stock: "Show stock",
  edit_items: "Редактировать элементы",
  edit_ticket: "Редактировать чек",
  split_check: "Раздельный чек",
  change_waiter: "Смена официанта",
  change_ticket: "Заменить чек",
  delete_ticket: "Удалить чек",
  show_all_tickets: "Показать все чеки",
  back_office: "Back office",
  employees_can_log_in_to_the_back_office_using_their_email_and_password:
    "Сотрудники могут входить в веб-кабинет, используя свой email и пароль",
  edit_profile: "Изменить профиль",
  set_the_taxes: "Установить налоги",
  manage_pos_devices: "Управление pos-устройствами",
  can_delete_item: "Can delete item",

  add_timecard: "Добавить табель учета рабочего времени",
  clock_in: "Время начала",
  clock_out: "Время окончания",
  total_hours: "Отработано часов",
  clock_in_date: "Дата начала",
  clock_out_date: "Дата окончания",
  clock_in_time: "Время входа",
  clock_out_time: "Время выхода",

  add_customer: "Добавить клиента",
  contacts: "Контакты",
  first_visit: "Первый визит",
  last_visit: "Последний визит",
  total_visits: "Всего визитов",
  total_spent: "Сумма покупок",
  points_balance: "Баланс баллов",
  first_name: "Имя",
  last_name: "Фамилия",

  general_settings: "Общие настройки",
  bussiness_name: "Название предприятия",
  UI_language: "Язык интерфейса",
  features: "Функции",
  track_cash_that_goes_in_and_out_of_your_drawer:
    "Вести учет наличных в кассе.",
  time_clock: "Учет рабочего времени сотрудников",
  track_employees_clock_in_out_time_and_calculate_their_total_work_hours: `Вести учет начала и окончания работы и рассчитывать отработанное время.`,
  allow_to_save_and_edit_orders_before_completing_a_payment:
    "Позволять сохранять и редактировать заказы до их оплаты.",
  show_my_debts: "Показать мои долги",
  open_receipts: "Открытые квитанции",
  save_receipt_as_unpaid: "Сохранить квитанцию как неоплаченную",
  orders: "Заказы",
  show_customer_order_section_and_and_get_orders:
    "Показать раздел заказа клиента и и получить заказы",
  chat: "Чат",
  show_support_chat_section: "Показать раздел чата поддержки",
  karaoke: "Караоке",
  can_sell_karaoke_type_item: "Можно отменить типы караоке",
  scale: "Масштаб",
  connect_to_scale_for_markets: "Подключитесь к масштабу для рынков",
  section: "Секции",
  enable_the_bar_printers: "Включите принтеры бара",
  inventery_menegment: "Складской учет",
  local_server: "Локальный сервер",
  share_tickets_in_a_local_area_call_us_before_turn_it_on:
    "Поделитесь билетами в окрестностях, позвоните нам, прежде чем включить!",
  cash: "Наличный сум",
  card: "Карта",
  gift: "Накопительная",
  debt: "Долг",
  qr_code: "QR Code",
  nfc: "NFC",
  online_payment: "Онлайн продажа",
  transfer_pay: "Перчисления",
  loyalty_settings: "Настройки лояльности",
  loyalty_type: "Тип лояльности",
  bonus_system: "Система бонусов",
  a_percentage_of_the_purchase_amount:
    "Процент от суммы покупки, которая будет создана за счет баллов клиента",

  add_tax: "Добавить налог",
  tax_rate: "Налоговая ставка, %",
  options: "Опции",

  add_predefined_ticket: "Добавить заранее определенный чек",

  add_printer_group: "Добавить группу принтеров",
  count: "Посчитать",

  add_store: "Добавить заведение",
  number_of_pos: "Количество POS",
  description: "Описание",

  add_pos: "Добавить",

  workgroup: "Рабочие группы",
  add_workgroup: "Добавить рабочие группы",
  create_employee: "Добавить сотрудник",

  variant: "Вариант",
  sales_by_modifier: "Продажи модификаторов",

  this_field_can_not_be_blank: "Это поле не может быть пустым",
  wrong_phone: "Неправильный номер телефона",

  update_customer: "Изменить",
  create_customer: "Добавить клиент",

  rest_debt: "Оставшийся долг",
  paid: "Оплачено",

  supplier_transaction: "Транзакции поставщиков",
  balance: "Баланс",
  document: "Документ",
  uzs: "UZS",
  usd: "USD",
  all_suppliers: "Все поставшики",
  coming: "Заказ",
  report_account: "Пожаловаться на аккаунт",
  all_cash: "Все наличные",
  all_card: "Все карты",
  consumption: "Потребление",
  fees: "Платёжи",
  one_time_fees: "Единичные расходы",
  salary: "Зарплата",
  company_to_fees: "Оплата поставщикам",
  create_fee: "Создать расходы",
  add_fee: "добавить расход",
  comment: "Коммент",
  amount_type: "Тип оплаты",
  service: "Сервисы",
  balance_type: "Тип баланса",
  currency: "Валюта",
  buttons: "Кнопки",
  add_button: "Добавить кнопка",
  pay_in: "Платить в",
  pay_out: "Выплачивать",
  none: "Никто",
  create_task: "Добавить бонусы",
  add_limit: "Добавить лимит",
  qty: "qty",
  kg: "kg",
  to: "To",
  from: "Из",
  bonus: "Бонус",
  unit_name: "Единица измерения",
  title: "заглавие",
  task: "Задача",
  a: "a",
  p: "p",
  add_task: "Добавить задачу",
  task_detail: "Информация о задаче",
  calculate_bonus_for_each: "Рассчитать бонус за каждый",
  item_mark: "Знак товара",
  shop: "Магазин",
  restaurant: "Ресторан",
  market: "Рынок",
  pricing: "Оценить",
  percent: "Процент",
  update_prices: "Обновить цены",
  all_items_from_the_supplier: "Все товары постащика",
  low_stock_items_from_the_supplier: "Заполнить товары с низким запасом",
  create_and_receive: "Создать и получить",
  composite_items: "Составные товары",
  non_composite: "Некомпозитный",
  box: "Коробка",
  litre: "Литр",
  metre: "Метр",
  active: "Активный",
  inactive: "Не активный",
  all_statuses: "All statuses",
  series: "Сырьё",
  count_by_type: "Считать по типу",
  this_field_can_not_be_only_space: "Это поле не может быть только пробелом",
  prices: "Цены",
  multi_prices: "Мульти цены",
  percent1: "Процентов1",
  percent2: "Процентов2",
  percent3: "Процентов3",
  margin1: "Прибыль1",
  price1: "Цена1",
  margin2: "Прибыль2",
  price2: "Цена2",
  margin3: "Прибыль3",
  price3: "Цена3",

  total_minutes: "Total worked minutes",
  total_work_time: "Total worked times",

  reminder: "Шт.",
  hot_key: "Хоткей",
  employees_can_use_inventory: "Сотрудники могут использовать инвентарь",
  purchase_orders_cost: "Стоимость заказов на закупку",
  stock_adjusment_cost: "Стоимость корректировки запасов",
  productions_cost: "Стоимость производства",
  receipt_settings: "Настройки чека",
  receipt: "Чеки",
  header: "Заглавие",
  footer: "Конец",
  show_customer_info: "Показать информацию о клиенте",
  show_comments: "Показать комментарии",
  emailed_receipt: "Отправить по почте",
  printed_receipt: "Печать",
  logo: "Логотип",
  items_for_scale: "Предметы для масштабирования",
  wrong_clock: "Неправильные часы",
  client: "Клиент",
  all_types: "Все типы",
  round: "Округлять",
  upload_file: "Загрузить файл",
  items_file: "Файл предметов",
  by_receipt: "По чеку",
  receipt_id: "Чек номер",
  use_sub_production: "Использовать подпроизводство",
  items_for_scale_txt: "Товары для весы .txt",
  no_rounding: "Не округлять",
  rounding_to_50_summ: "Округлять на 50 сум",
  rounding_to_500_summ: "Округлять на 500 сум",
  both: "Оба",
  "1 qty": "1 шт.",
  "2 qty": "2 шт.",
  "3 qty": "3 шт.",
  action: "Действие",
  apply: "применять",
  margin_next: "Маржа следующая",
  price_next: "Цена следующая",

  couldnot_update_prices: "Не удалось обновить цены",
  purchase_mark: "Знак покупки",
  last_date_pricing: "цена на последнюю дату",
  create_purchase_mark: "Создать отметку о покупке",
  supplier_transaction_corrector: "Корректор сделок с поставщиками",
  get_back: "Вернуться",
  item_price_change_history: "История изменения цены товара",
  old_price: "Старая цена",
  new_price: "Новая цена",
  nds: "НДС",
  a_percentage_of_the_nds: "Процент от НДС",
  nds_settings: "Настройки НДС",
  can_sell: "Может продать",
  auto_fill: "Автозаполнение",
  fill_sold: "Заполнить продано",
  last_come: "Последний пришел",
  use_purchase_cost_on_pricing:
    "Использовать стоимость покупки при расчете цены",
  sales_by_supplier: "Продажи поставщиком",
  search: "Поиск",
  no_item_found: "Ничего не найдено",
  create_items: "Создать товары",
  add_new: "Добавить новый",
  please_enter_valid_barcode: "Пожалуйста, введите действительный штрих-код",
  item_allready_exist: "Товар уже существует",
  error_on_saving: "Ошибка при сохранении",
  creating_item: "Создание предметов",
  updating_item: "Обновление предметов",
  confirm: "Подтвердить",
  add_from_warehause: "Добавить со склада",
  add_items_from_warehause_quickly: "Быстро добавляйте товары со склада",
  items_for_scale_second_txt: "Элементы для масштабирования второго txt",
  pcs: "Шт.",
  reminder_changed: "Остаток изменился",
  RLS1200: "RLS1200",
  add_order: "Добавить заказ",
  created_date: "Дата создания",
  state: "Статус",
  no_workgroup_orders: "В рабочей группе заказов нет",
  priority: "Срочность",
  urgent: "Высокая",
  normal: "Средняя",
  low: "Низкая",
  no_clients_found: "Клиентов не найдено",
  no_stores_found: "Магазины не найдены",
  choose_at_least_one_item: "Выберите хотя бы один товар",
  reset_workgroups: "Сбросить рабочие группы",
  workgroup_orders: "Заказы",
  info: "Инфо",
  workgroups: "Рабочие группы",
  used_quantity: "Использованное количество",
  doing: "Делание",
  done: "Завершено",
  rejected: "Отклонено",
  undo_rejecked: "Отменить отклонено",
  confirm_complete: "Завершить",
  total_cost: "Общая цена",
  additional: "Дополнительные",
  total_amount: "Обшая сумма",
  total_actual_cost: "Цена сырья",
  complete_confirmed: "Завершить",
  workgroup_order: "Заказы",
  paid_debt: "Оплаченный долг",
  total_debt: "Общий долг",
  client_debt_by_category: "Клиентская задолженность по категориям",
  by_name: "По имени",
  past_debt: "Прошлый долг",
  order_information: "Информация о заказе",
  device_information: "Информация об устройстве",
  add_device_information: "Добавить информацию об устройстве",
  add_order_information: "Добавить информацию о заказе",
  back: "Назад",
  show_order_info: "Показать информацию о заказе",
  show_device_info: "Показать информацию об устройстве",
  workgroup_items: "Сырьё",
  loading_info: "Загрузка",
  no_info_yet: "Информации пока нет",
  order_info: "Информация о заказе",
  device_info: "Информация об устройстве",
  workgroup_comments: "Комментарии к рабочим группам",
  add_workgroup_comment: "Добавить комментарий рабочей группы",
  production_item: "Изделие производства",
  total_production_cost: "Цена с учетом других расходов",
  text: "Текст",
  show_shifts: "Смена",
  additional_information: "Дополнительная информация",
  add_additional_information: "Добавьте дополнительную информацию",
  additional_info: "Дополнительная информация",
  show_additional_info: "Показать дополнительную информацию",
  workgroup_edit_cost: "Стоимость редактирования рабочей группы",
  employees_can_use_workgroup: "Сотрудники могут использовать рабочую группу",
  super_password: "Супер пароль",
  residue: "Остаток",
  device_name: "Аппарат №",
  start_time: "Начало",
  finish_time: "Конец",
  save_as_draft: "Cохранить как черновик",
  draft: "В черновике",
  edit_workgroup_order: "Изменить порядок в рабочей группе",
  currency_type: "Тип валюты",
  edit_current_receipt: "Редактировать текущий чек",
  customer_detail: "Сведения о клиенте",
  pay_customer_debt: "Оплатить долг клиента",
  user_type: "Выберите тип клиента",
  natural_user: "Физическое лицо",
  legal_user: "Юридическое лицо",
  product_name: "Наименование товара",
  currency_value: "Курс валюты",
  debt_history: "История долгов",
  receipt_save_as_draft: "Квитанция сохранить как черновик",
  from_time: "От",
  to_time: "До",
  can_change_price: "Можно изменить цену",
  warehause: "Склад",
  wharehouse_manager: "Завсклад",

  edit_sold_item: "Изменить",
  all_categories: "Все категории",
  stock: "В наличии",

  supplier_contract: "Договор №",

  fee: "Расходы",
  created_at: "Создан",
  order_number: "№ заказа",
  workgroup_orders_report: "Отчет рабочей группы",
  total_actual_cost_sum: "Фактическая стоимость",
  total_production_cost_sum: "Общая стоимость производства",
  can_access_to_shift: "Может получить доступ к смене",
  add_receipt: "Добавить чек",
  create_receipt: "Создать чек",
  option: "Опции",
  transfer: "Перевод",
  reports_safe: "Отчеты",
  by_user: "По пользователю",
  uzs_value: "Сум",
  usd_value: "Доллары",
  transfer_value: "Стоимость перевода",
  customer_debt: "Задолженность клиента",
  tech_map: "Техническая карта",
  add_tech_map: "Добавить техническую карту",
  tech_map_detail: "Детали технической карты",
  quality: "Количесто",
  tech_map_item: "Элемент технической карты",
  by_tech_map: "По технической карте",
  show_all: "Показать все",
  allready_exist: "Уже существует",
  add_to_stock: "Добавить на склад",

  transaction_documents: "Документы сделки",
  create_document: "Создать документ",
  report_by_items: "Отчет по товарам",
  adjust: "Изменить",
  total_spend: "Общие расходы",
  total_receive: "Всего получить",
  total_favor: "Общая",

  credit: "Кредит",

  price_for_pieces: "Цена шт.",
  workgroup_orders_report_by_employee: "Отчет рабочей группы по сотруднику",
  employee_name: "Имя сотрудника",
  workgroup_name: "Имя рабочей группы",
  enter_receipt_letter: "Имя рабочей группы",
  receipt_letter: "Письмо о получении",
  refund_receipt: "Чек о возврате",
  service_name: "Наименование услуги",
  client_name: "Имя клиента",
  reset_count: "Сбросить счетчик",
  last_priced_goods: "Товар по последней цене",
  item_for_mettletoledo: "Mettler toledo SPCT2",
  item_for_mettletoledo_spct1: "Mettler toledo SPCT1",
  item_for_cas_turkish: "Cas Turkish ",
  set_client: "Выбрать клиент",
  delivery: "Доставка",
  non_store: "Сервис",
  store_items: "Товары",
  telegram_acces: "Доступ на телеграм",
  mxik: "Код ИКПУ",
  sub_position_uz: "Название субпозиции",
  brand: "Бренд",
  organization: "Oрганизация",
  group_name_uz: "Название группы",
  class_name_uz: "Название класса",
  position_uz: "Название позиции",
  attribute_uz: "Название атрибута",
  unit: "Код единицы измерения (упаковки)",
  unit_of_pack: "Единица измерение (упаковка)",
  mxik_search: "Код ИКПУ поиск",
  nds_value: "НДС",
  cash_backs: "Накопительная",
  employees_can_use_reports: "Сотрудники могут использовать отчеты",
  report: "Отчеты",
  sale_summary: "Сводка продаж",
  accaunt: "Аккаунт",
  abs: "АБС-анализ",
  sale_by_item: "Продажи по товарам",
  sale_by_category: "Продажи по категориям",
  sale_by_supplier: "Продажи поставщиком",
  sale_by_payment: "Продажи по платеж",
  shift: "Смены",
  employees_can_use_items: "Сотрудники могут использовать продукты",
  list: "Товары",
  print_label: "Печать этикетки",
  price_change_history: "История изменения цен",
  employees_can_use_settings: "Сотрудники могут использовать настройки",
  time_cards: "Рабочие часы",
  can_use_employees: "Можно использовать сотрудников",
  total_worked: "Общее количество отработанных часов",
  employees_can_use_customers: "Сотрудники могут использовать клиентов",
  create_taxes: "Создать налоги",
  create_store: "Создать магазин",
  create_pos_device: "Создать POS-устройство",
  create_access: "Создать доступ",
  create_time_card: "Создать карточку учета рабочего времени",
  create_stock_adjustmen: "Создать корректировку запаса",
  create_inv_count: "Создать инвентаризацию",
  create_supplier_create_doc: "Создать документ",
  create_good_sale: "Создать товары",
  create_good_category: "Создать категорию товаров",
  create_modifier: "Создать модификатор",
  create_discount: "Создать скидку",
  create_reciept: "Создать продажу",
  employees_can_use_create: "Сотрудники могут использовать создание",
  potential: "Потенциал",
  retail: "Розничная торговля",
  item_edit: "Изменить товар",
  supplier_valuation: "Oстатка поставщик",
  error_404_sorry: "Извините, у вас нет  доступ к этой странице!",
  export_item_excel: "скачать",
  partition_item: "Партийный учет",
  all_amount: "Все",
  item_mark_edit: "Изменить цены",
  beta: "бета",
  add_mark: "Создать отметку",
  partition_valuation: "Партионный остаток",
  inn: "ИНН",
  organization_name: "Название организации",
  organizations: "Организации",
  loyalty_bonus: "loyalty_bonus",
  epos_token: "epos_token",
  zero: "Нет в наличии",
  not_zero: "Есть в наличии",
  quantity_left: "Осталась",
  purchase_employee: "Внутренные заказы",
  real_stock: "Остаток",
  accept_by: "Заказ принял",
  accept: "Принял",
  dimentions: "Размеры",
  show_on_bot: "показать на боте",
  discount: "Скидка",
  reciepts_count: "Кол-во чеков",
  average_reciept: "Средный чек",
  user_id: "ID пользователя",
  director_name: "Имя директора",
  accaunter: "бухгалтер",
  taxes_pair_code: "Код пары налогов",
  org_phone_number: "Телефон организации",
  import_items_excel: "Import items excel",
  promotions_and_discounts: "Promotions and discounts",
  download: "Скачать",
  marking: "Marking",
  is_refund: "Is refund",
  client_status: "Client status",
  add_status: "Add status",
  club_card: "Club card",
  new_item_create: "New item create",
  material_report: "Материалный отчет",
  partiation_no: "№ партии",
  qty_box: "Кор.шт",
  sale_report: "Отчет о продаже",
  partition: "Партия №",
  import_by_barcode: "Import by barcode",
  cashback_out: "Kэшбэк",
  birthday: "День рождения",
  gender: "Пол",
  male: "Мужской",
  female: "Женский",
  packages: "Пакеты",
  working_days: "Рабочие дни",

  checkedProductsCount: "Checked products count",
  syncProductsCount: "Synced products count",
  syncNotStarted: "Sync not started. Click sync to start",
  sync: "sync",
  startedAt: "Stared at",
  endedAt: "Finished at",
};
